import hoopSocialSidebar from './widgets/hoopSocialSidebar.js';
import hoopQuickLinks from './widgets/hoopQuickLinks.js';
import hoopCountdown from './widgets/hoopCountdown.js';
import hoopMainSlideshow from './widgets/hoopMainSlideshow.js';
// import hoopMainVideoFeature from './widgets/hoopMainVideoFeature.js';
import hoopCards from './widgets/hoopCards.js';
import hoopSEO from './widgets/hoopSEO.js';
import hoopTierFourCards from './widgets/hoopTierFourCards.js';
import hoopSponsors from './widgets/hoopSponsors.js';
import hoopFooterBG from './widgets/hoopFooterBG.js';
import hoopHeaderButton from './widgets/hoopHeaderButton.js';
import videoWidget from '../../widgets/videoWidget.js';

function hooplandiaStructure() {
  if ($('body').hasClass('hooplandiaHomepage')) {
    hoopMainSlideshow();
    $(`#hoopMainSlideshow`).appendTo('.subpage-hoop-container .tier-one #slideshow-wrap');
    setTimeout(() => {
      $('#slideshow-wrap').css('opacity', '1');
    }, 1500);
    $(window).load(function () {
      videoWidget();
    });

    hoopCards();
    hoopSEO();

    hoopTierFourCards();
  }

  if ($('body').hasClass('hooplandiaTheme')) {
    hoopQuickLinks();
    hoopCountdown();
    hoopFooterBG();
    hoopSponsors();
    hoopSocialSidebar();
    $('.swiperWidgetBannerAd').remove();
    hoopHeaderButton();
  }
}

export { hooplandiaStructure };
